export function updateUserPreferences(userId, preferences, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/users/${userId}/settings`;
  return apiClient.patch(route, preferences);
}

export default { updateUserPreferences };
